import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import cn from 'classnames';
import moment from 'moment';
import last from 'lodash/last';

import { generateRoomURL, getMessageSnippet, getUserFullName } from '../../utils/utilsChat';
import { exposeComponentToGlobalScope } from '../../utils/utilsGlobal';
import { getAnalyticsOperatorMessages } from '../../services/apiAnalytics';
import services, { events } from '../../services/services';
import {
  Dropdown,
  FormattedMarkdown,
  ChatMessagesAttachments,
} from '../../components';

import styles from './AnalyticsOperatorMessages.scss';
import uiStyles from '../../styles/ui.scss';


const mapStateToProps = state => {
  return {
    currentCompany: state.currentCompany,
    currentCompanyOperators: state.currentCompanyOperators,
  };
};

@connect(mapStateToProps, null)
export class AnalyticsOperatorMessages extends Component {

  OPERATOR_MESSAGE_CHUNK_SIZE = 50;

  state = {
    isLoading: false,
    operatorFilterOptions: [],
    operatorFilterTitle: '',
    selectedOperatorId: null,
    operatorMessages: [],
    hasLoadedAllMessages: false,
  };

  componentDidMount() {
    services.userWatcher.on(events.USER_SET_SUCCESS, () => {
      const operatorFilterOptions = this.generateOperatorFilterOptions();
      this.setState({ operatorFilterOptions });
      this.onOperatorFilterChange(operatorFilterOptions[0]);
    });
    exposeComponentToGlobalScope(this);
  }

  getOperatorMessages = (operatorId) => {
    const { currentCompany } = this.props;
    const params = {
      companyId: currentCompany.id,
      operatorId,
      limit: this.OPERATOR_MESSAGE_CHUNK_SIZE,
      afterCursor: null,
    };

    this.setState({ isLoading: true });

    getAnalyticsOperatorMessages(params).then(operatorMessages => {
      const hasLoadedAllMessages = operatorMessages.length < this.OPERATOR_MESSAGE_CHUNK_SIZE;
      this.setState({
        operatorMessages,
        hasLoadedAllMessages,
        isLoading: false,
      });
    });
  };

  loadAdditionalOperatorMessages = () => {
    const { currentCompany } = this.props;
    const { selectedOperatorId, operatorMessages } = this.state;
    const latestCursor = last(operatorMessages).cursor;

    if (latestCursor) {
      const params = {
        companyId: currentCompany.id,
        operatorId: selectedOperatorId,
        limit: this.OPERATOR_MESSAGE_CHUNK_SIZE,
        afterCursor: latestCursor,
      };
      getAnalyticsOperatorMessages(params).then(additionalOperatorMessages => {
        const hasLoadedAllMessages = additionalOperatorMessages.length < this.OPERATOR_MESSAGE_CHUNK_SIZE;

        this.setState({
          operatorMessages: [
            ...operatorMessages,
            ...additionalOperatorMessages,
          ],
          hasLoadedAllMessages,
        });
      });
    }
  };

  onOperatorFilterChange = (selectedOption) => {
    const selectedOperatorId = selectedOption.value;
    const operatorFilterTitle = selectedOption.title;

    this.setState({ selectedOperatorId, operatorFilterTitle });

    if (selectedOperatorId) {
      this.getOperatorMessages(selectedOperatorId);
    }
  };

  generateOperatorFilterOptions = () => {
    const { currentCompanyOperators } = this.props;
    return currentCompanyOperators.map((operator, i) => {
      return {
        title: getUserFullName(operator),
        value: operator.id,
      };
    });
  };

  renderRoomTitle = (message, i) => {
    const { operatorMessages } = this.state;
    const previousMessageId = operatorMessages[i - 1]?.room?.id;
    if (message.room.id !== previousMessageId) {
      return message.room.title;
    }
  };

  render(){
    const { className, currentCompany, renderReportMenu } = this.props;
    const {
      isLoading,
      operatorFilterOptions,
      operatorFilterTitle,
      selectedOperatorId,
      operatorMessages,
      hasLoadedAllMessages,
    } = this.state;

    return (
      <div className={className}>
        <div className={styles.filterContainer}>

          {renderReportMenu()}

          <Dropdown
            className={styles.filterItem}
            items={operatorFilterOptions}
            buttonAppearance={true}
            dontKeepSelectedOption={true}
            onChange={this.onOperatorFilterChange}>
            {operatorFilterTitle}
          </Dropdown>
        </div>

        {Boolean(selectedOperatorId) && !Boolean(operatorMessages.length) && !isLoading && (
          <div className={styles.noMessages}>Нет сообщений</div>
        )}

        {Boolean(selectedOperatorId) && Boolean(operatorMessages.length) && (
          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th className={cn(styles.tableCell, styles.tableCellTitle, styles.tableColumnRoomName)}>
                    Клиент
                  </th>
                  <th className={cn(styles.tableCell, styles.tableCellTitle, styles.tableColumnMessage)}>
                    Сообщение оператора
                  </th>
                </tr>
              </thead>
              <tbody>
                {operatorMessages.map((message, i) => (
                  <tr key={message.id}>
                    <td className={styles.tableCell}>
                      <span className={styles.roomName}>
                        {this.renderRoomTitle(message, i)}
                      </span>
                    </td>
                    <td className={styles.tableCell}>

                      {Boolean(message.responseToMessage.id) && (
                        <div className={styles.messageResponse}>
                          {!message.responseToMessage.isDeleted && (
                            <Fragment>
                              {getUserFullName(message.responseToMessage.sender)}&nbsp;
                              <span title={message.responseToMessage.text}>
                                {getMessageSnippet(message.responseToMessage)}
                              </span>
                            </Fragment>
                          )}
                          {message.responseToMessage.isDeleted && (
                            <span>Сообщение удалено</span>
                          )}
                        </div>
                      )}

                      <FormattedMarkdown
                        className={styles.messageText}
                        markdown={message.text}/>

                      <ChatMessagesAttachments
                        attachments={message.attachments}
                        onPreviewClick={() => {}}/>

                      <div className={styles.messageFooter}>
                        <span className={styles.messageFooterItem}>
                          {moment(message.timestamp).format('h:mm')}
                        </span>
                        <span className={styles.messageFooterItem}>
                          {moment(message.timestamp).format('D MMMM YYYY')}
                        </span>
                        <a className={styles.messageLink}
                          href={generateRoomURL(currentCompany.id, message.id)}
                          target="_blank"
                          hidden>
                          Перейти к сообщению
                        </a>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {!hasLoadedAllMessages && (
              <span className={uiStyles.link} onClick={this.loadAdditionalOperatorMessages}>
                Загрузить еще
              </span>
            )}
          </div>
        )}
      </div>
    );
  }
}
